/**
 * Stacked-card carousel — homepage slideshow (all breakpoints) + product media (mobile only).
 * Slideshow: Aqua peek/swipe/pill-nav; Staze desktop side arrows + optional hide-dots (≥1150).
 */
(function () {
  if (window.__hdtSlideshowStackMobileInit) return;
  window.__hdtSlideshowStackMobileInit = true;

  var MQ = window.matchMedia('(max-width: 767px)');
  var MQ_DESKTOP = window.matchMedia('(min-width: 1150px)');
  var STACK_ROOT_SELECTOR = '.hdt-slideshow--stack-mb, .hdt-product-media--stack-mb';

  function getStackConfig(slider) {
    if (slider.classList.contains('hdt-slideshow--stack-mb')) {
      return {
        viewportSelector: '.hdt-slideshow-stack-mobile',
        slideSelector: '.hdt-slideshow-stack-mobile .hdt-slider__slide',
        isProduct: false,
        /* Slideshow stack runs on mobile + tablet + desktop */
        stackAlways: true
      };
    }
    if (slider.classList.contains('hdt-product-media--stack-mb')) {
      return {
        viewportSelector: '.hdt-product-media-stack-mobile',
        slideSelector: '.hdt-product-media-stack-mobile .hdt-slider__slide:not([hidden])',
        isProduct: true,
        stackAlways: false
      };
    }
    return null;
  }
  var STACK_CLASSES = [
    'hdt-stack-active',
    'hdt-stack-behind-1',
    'hdt-stack-behind-2',
    'hdt-stack-next',
    'hdt-stack-prev',
    'hdt-stack-next-2',
    'hdt-stack-exit-left',
    'hdt-stack-exit-right',
    'hdt-stack-hidden'
  ];
  var DOT_SELECTED = 'hdt-slider__dot--selected';
  var DEFAULT_AUTOPLAY_MS = 5000;
  var SWIPE_THRESHOLD = 35;
  var NAV_INDICATOR_WIDTH = 20;
  var NAV_TRACK_MIN_WIDTH = 80;
  var NAV_TRACK_PER_SLIDE = 20;

  function normalizePos(pos, total) {
    if (total <= 1) return pos;
    while (pos > total / 2) pos -= total;
    while (pos < -total / 2) pos += total;
    return pos;
  }

  function getDelayMs(slide) {
    var raw = slide && slide.getAttribute('data-autoplay-delay');
    var parsed = raw ? parseInt(raw, 10) : NaN;
    return Number.isFinite(parsed) && parsed > 0 ? parsed : DEFAULT_AUTOPLAY_MS;
  }

  function initStackSlideshow(slideshow) {
    var stackConfig = getStackConfig(slideshow);
    if (!slideshow || !stackConfig) return;
    if (slideshow.dataset.stackMobileInit === 'true') return;
    slideshow.dataset.stackMobileInit = 'true';

    var slideSelector = stackConfig.slideSelector;
    var viewportSelector = stackConfig.viewportSelector;
    var dotsContainer = slideshow.querySelector('[hdt-slider-dots]');
    var loop = false;
    var currentIndex = 0;
    var exitTimer = null;
    var autoplayTimer = null;
    var touchStartX = 0;
    var touchStartY = 0;
    var touchActive = false;
    var transitioning = false;

    // Real-time drag state (product Tinder gallery only)
    var dragCard = null;
    var dragIncoming = null;
    var dragStartX = 0;
    var dragStartY = 0;
    var dragDX = 0;
    var dragLock = null;
    var THROW_THRESHOLD = 90;
    var MAX_DRAG_ROTATE = 15;

    try {
      loop = JSON.parse(slideshow.getAttribute('config') || '{}').loop === true;
    } catch (e) {}

    function isStackActive() {
      return stackConfig.stackAlways || MQ.matches;
    }

    /* Hide dots only on true desktop; keep pill nav on tablet */
    function hideDotsOnDesktop() {
      return slideshow.classList.contains('hdt-slideshow--hide-dots-dk') && MQ_DESKTOP.matches;
    }

    function getSlides() {
      return slideshow.querySelectorAll(slideSelector);
    }

    function getTotal() {
      return getSlides().length;
    }

    function clearStackClasses(slide) {
      STACK_CLASSES.forEach(function (cls) {
        slide.classList.remove(cls);
      });
    }

    function clearInlineStyles(slide) {
      slide.style.removeProperty('transform');
      slide.style.removeProperty('left');
      slide.style.removeProperty('right');
      slide.style.removeProperty('opacity');
      slide.style.removeProperty('visibility');
      slide.style.removeProperty('transition');
      slide.style.removeProperty('pointer-events');
      slide.style.removeProperty('z-index');
    }

    /**
     * Embla (AutoHeight + scrollTo) runs after our stack classes are applied and
     * collapses the original multi-slide stack visually. Undo that interference
     * on mobile without changing the original next/prev/next-2 layering.
     */
    function neutralizeEmblaInterference() {
      if (!stackConfig.isProduct || !MQ.matches) return;

      var viewport = slideshow.querySelector(viewportSelector);
      var container = slideshow.querySelector(viewportSelector + ' .hdt-slider__container');

      if (viewport) {
        viewport.style.setProperty('overflow', 'visible', 'important');
        viewport.style.setProperty('height', 'auto', 'important');
        viewport.style.removeProperty('max-height');
      }

      if (container) {
        container.style.setProperty('transform', 'none', 'important');
        container.style.removeProperty('height');
      }

      getSlides().forEach(function (slide) {
        if (
          slide.classList.contains('hdt-stack-active') ||
          slide.classList.contains('hdt-stack-next') ||
          slide.classList.contains('hdt-stack-prev') ||
          slide.classList.contains('hdt-stack-next-2')
        ) {
          slide.style.removeProperty('transform');
          slide.style.removeProperty('left');
          slide.style.removeProperty('right');
          slide.style.removeProperty('opacity');
          slide.style.removeProperty('visibility');
        }
      });
    }

    function syncThumbOnly(selectedIndex) {
      var thumbId = slideshow.getAttribute('aria-controls');
      if (!thumbId) return;
      var thumb = document.getElementById(thumbId);
      if (thumb && typeof thumb.goToIndex === 'function') {
        try {
          thumb.goToIndex(selectedIndex, true);
        } catch (e) {}
      }
    }

    function stackLayersMissing() {
      var slides = getSlides();
      var total = slides.length;
      if (total <= 1) return false;
      var active = slides[currentIndex];
      if (!active || !active.classList.contains('hdt-stack-active')) return true;
      if (currentIndex + 1 < total && !slides[currentIndex + 1].classList.contains('hdt-stack-next')) {
        return true;
      }
      if (currentIndex + 2 < total && !slides[currentIndex + 2].classList.contains('hdt-stack-next-2')) {
        return true;
      }
      return false;
    }

    function refreshStackAfterEmbla() {
      if (!MQ.matches || !stackConfig.isProduct || transitioning || dragCard) return;
      neutralizeEmblaInterference();
      if (stackLayersMissing()) {
        applyStack(currentIndex, null, { skipEmblaSync: true });
      }
    }

    function bindEmblaStackGuard() {
      if (!stackConfig.isProduct || slideshow.dataset.stackEmblaGuard === 'true') return;
      slideshow.dataset.stackEmblaGuard = 'true';

      ['init', 'select', 'reInit'].forEach(function (eventName) {
        slideshow.addEventListener(eventName + ':slide', function () {
          requestAnimationFrame(function () {
            requestAnimationFrame(refreshStackAfterEmbla);
          });
        });
      });
    }

    function clampIndex(index) {
      var total = getTotal();
      if (total <= 1) return 0;
      if (index < 0) return loop ? total - 1 : 0;
      if (index >= total) return loop ? 0 : total - 1;
      return index;
    }

    function enableNavButtons() {
      var prevBtn = slideshow.querySelector('.hdt-slider__button--prev');
      var nextBtn = slideshow.querySelector('.hdt-slider__button--next');
      if (prevBtn) prevBtn.removeAttribute('disabled');
      if (nextBtn) nextBtn.removeAttribute('disabled');
    }

    function showDotsContainer() {
      if (!dotsContainer) return;
      if (hideDotsOnDesktop()) {
        dotsContainer.setAttribute('hidden', '');
        return;
      }
      dotsContainer.removeAttribute('hidden');
      slideshow.classList.remove('hdt-hidden-slider-dots');
      var viewport = slideshow.querySelector(viewportSelector);
      if (viewport) viewport.classList.remove('hdt-hidden-slider-dots');
    }

    function ensureDots() {
      if (!dotsContainer || !isStackActive()) return;
      if (hideDotsOnDesktop()) {
        dotsContainer.setAttribute('hidden', '');
        return;
      }

      var total = getTotal();
      if (total <= 1) return;

      showDotsContainer();

      if (dotsContainer.children.length !== total) {
        var html = '';
        for (var i = 0; i < total; i++) {
          html += '<button class="hdt-slider__dot" type="button"></button>';
        }
        dotsContainer.innerHTML = html;
      }

      if (!stackConfig.isProduct) {
        dotsContainer.classList.add('hdt-stack-pill-nav');
        setNavIndex(currentIndex, false);
      }
    }

    function watchDotsContainer() {
      if (!dotsContainer || dotsContainer.dataset.stackDotsWatch === 'true') return;
      dotsContainer.dataset.stackDotsWatch = 'true';

      new MutationObserver(function () {
        if (!isStackActive() || hideDotsOnDesktop()) return;
        var total = getTotal();
        if (total <= 1) return;
        if (
          dotsContainer.children.length !== total ||
          dotsContainer.hasAttribute('hidden') ||
          slideshow.classList.contains('hdt-hidden-slider-dots')
        ) {
          ensureDots();
          updateDots(currentIndex);
        }
      }).observe(dotsContainer, {
        childList: true,
        attributes: true,
        attributeFilter: ['hidden']
      });

      new MutationObserver(function () {
        if (!isStackActive() || hideDotsOnDesktop()) return;
        if (slideshow.classList.contains('hdt-hidden-slider-dots')) {
          showDotsContainer();
        }
      }).observe(slideshow, {
        attributes: true,
        attributeFilter: ['class']
      });
    }

    function getNavTrackWidth(total) {
      return Math.max(NAV_TRACK_MIN_WIDTH, total * NAV_TRACK_PER_SLIDE);
    }

    function setNavIndex(index, isDragging) {
      if (!dotsContainer || stackConfig.isProduct || hideDotsOnDesktop()) return;
      var total = dotsContainer.children.length;
      if (total <= 0) return;

      var maxIndex = total - 1;
      var positionIndex = Math.max(0, Math.min(maxIndex, index));
      var trackWidth = getNavTrackWidth(total);

      dotsContainer.style.width = trackWidth + 'px';
      dotsContainer.style.setProperty('--hdt-stack-nav-track-width', trackWidth + 'px');
      dotsContainer.style.setProperty('--hdt-stack-nav-total', String(total));
      dotsContainer.classList.toggle('is-nav-dragging', !!isDragging);

      function applyOffset() {
        if (!dotsContainer) return;
        var measuredWidth = dotsContainer.getBoundingClientRect().width || trackWidth;
        var maxOffset = Math.max(measuredWidth - NAV_INDICATOR_WIDTH, 0);
        var offsetPx;

        if (total <= 1) {
          offsetPx = maxOffset / 2;
        } else {
          offsetPx =
            (positionIndex + 0.5) * (measuredWidth / total) - NAV_INDICATOR_WIDTH / 2;
          offsetPx = Math.max(0, Math.min(maxOffset, offsetPx));
        }

        dotsContainer.style.setProperty('--hdt-stack-nav-offset', offsetPx + 'px');
      }

      applyOffset();

      if (!dotsContainer.getBoundingClientRect().width) {
        requestAnimationFrame(applyOffset);
      }
    }

    function watchNavResize() {
      if (!dotsContainer || dotsContainer.dataset.stackNavResizeWatch === 'true') return;
      dotsContainer.dataset.stackNavResizeWatch = 'true';

      if (typeof ResizeObserver === 'undefined') return;

      new ResizeObserver(function () {
        if (!isStackActive() || hideDotsOnDesktop()) return;
        setNavIndex(currentIndex, dotsContainer.classList.contains('is-nav-dragging'));
      }).observe(dotsContainer);
    }

    function updateDots(selectedIndex) {
      if (!dotsContainer || hideDotsOnDesktop()) return;
      ensureDots();
      var dots = dotsContainer.children;
      for (var i = 0; i < dots.length; i++) {
        if (i === selectedIndex) {
          dots[i].classList.add(DOT_SELECTED);
          dots[i].setAttribute('aria-current', 'true');
        } else {
          dots[i].classList.remove(DOT_SELECTED);
          dots[i].removeAttribute('aria-current');
        }
      }

      setNavIndex(selectedIndex, false);

      var slides = getSlides();
      var currentSlide = slides[selectedIndex];
      var delayMs = getDelayMs(currentSlide);
      var sectionEl = slideshow.closest('[id^="shopify-section"]') || slideshow;
      sectionEl.style.setProperty('--section-autoplay', delayMs / 1000 + 's');
    }

    function applyStack(selectedIndex, direction, options) {
      options = options || {};
      var skipEmblaSync = options.skipEmblaSync === true;
      var slides = getSlides();
      var total = slides.length;
      if (!total) return;

      selectedIndex = clampIndex(selectedIndex);
      slideshow.setAttribute('data-stack-ready', 'true');

      var container = slideshow.querySelector(viewportSelector + ' .hdt-slider__container');
      if (container) container.style.setProperty('transform', 'none', 'important');

      var allSlides = slideshow.querySelectorAll(viewportSelector + ' .hdt-slider__slide');
      var exitingSlides = [];

      allSlides.forEach(function (slide) {
        // Freeze exiting slides before class swap to avoid ghost snap-back.
        if (
          !direction &&
          (slide.classList.contains('hdt-stack-exit-left') ||
            slide.classList.contains('hdt-stack-exit-right'))
        ) {
          exitingSlides.push(slide);
          slide.style.setProperty('transition', 'none', 'important');
          slide.style.setProperty('opacity', '0', 'important');
          slide.style.setProperty('visibility', 'hidden', 'important');
        }
        clearStackClasses(slide);
        clearInlineStyles(slide);
        if (exitingSlides.indexOf(slide) !== -1) {
          slide.style.setProperty('transition', 'none', 'important');
          slide.style.setProperty('opacity', '0', 'important');
          slide.style.setProperty('visibility', 'hidden', 'important');
        }
        slide.classList.remove('is-selected');
      });

      var previousIndex = currentIndex;

      slides.forEach(function (slide, index) {
        if (direction && index === previousIndex && selectedIndex !== previousIndex) {
          slide.classList.add(direction === 'next' ? 'hdt-stack-exit-left' : 'hdt-stack-exit-right');
          return;
        }

        var pos = normalizePos(index - selectedIndex, total);

        if (pos === 0) {
          slide.classList.add('hdt-stack-active');
        } else if (stackConfig.isProduct) {
          if (pos === 1) slide.classList.add('hdt-stack-next');
          else if (pos === 2) slide.classList.add('hdt-stack-next-2');
          else slide.classList.add('hdt-stack-hidden');
        } else {
          if (pos === 1) slide.classList.add('hdt-stack-behind-1');
          else if (pos === 2) slide.classList.add('hdt-stack-behind-2');
          else slide.classList.add('hdt-stack-hidden');
        }
      });

      currentIndex = selectedIndex;
      slides.forEach(function (slide, index) {
        slide.classList.toggle('is-selected', index === selectedIndex);
      });
      updateDots(selectedIndex);
      enableNavButtons();
      neutralizeEmblaInterference();

      if (exitingSlides.length) {
        requestAnimationFrame(function () {
          exitingSlides.forEach(function (slide) {
            slide.style.removeProperty('transition');
            slide.style.removeProperty('opacity');
            slide.style.removeProperty('visibility');
          });
        });
      }

      if (!skipEmblaSync) syncEmbla(slides[selectedIndex]);
    }

    function syncEmbla(activeSlide) {
      if (!stackConfig.isProduct || !activeSlide) return;

      if (MQ.matches) {
        syncThumbOnly(currentIndex);
        neutralizeEmblaInterference();
        return;
      }

      if (typeof slideshow.goToTarget !== 'function') return;
      try {
        slideshow.goToTarget(activeSlide, true);
      } catch (e) {}
    }

    function clearAutoplay() {
      if (autoplayTimer) {
        clearTimeout(autoplayTimer);
        autoplayTimer = null;
      }
    }

    function scheduleAutoplay() {
      clearAutoplay();
      if (!isStackActive()) return;
      if (!slideshow.hasAttribute('data-per-slide-autoplay')) return;

      var slides = getSlides();
      if (slides.length <= 1) return;

      var delayMs = getDelayMs(slides[currentIndex]);
      autoplayTimer = setTimeout(function () {
        goNext(true);
      }, delayMs);
    }

    function goToSlide(index, direction, fromAutoplay) {
      if (!isStackActive() || transitioning) return;

      var total = getTotal();
      if (total <= 1) return;

      var nextIndex = clampIndex(index);

      if (nextIndex === currentIndex && !direction) {
        applyStack(nextIndex, null);
        return;
      }

      if (!direction) {
        var delta = nextIndex - currentIndex;
        if (loop) {
          if (delta > total / 2) delta -= total;
          if (delta < -total / 2) delta += total;
        }
        direction = delta >= 0 ? 'next' : 'prev';
      }

      transitioning = true;
      applyStack(nextIndex, direction);

      if (exitTimer) clearTimeout(exitTimer);
      exitTimer = setTimeout(function () {
        applyStack(currentIndex, null);
        transitioning = false;
        if (!fromAutoplay) scheduleAutoplay();
      }, 520);

      if (fromAutoplay) {
        setTimeout(function () {
          transitioning = false;
          scheduleAutoplay();
        }, 540);
      } else {
        clearAutoplay();
      }
    }

    function goNext(fromAutoplay) {
      goToSlide(currentIndex + 1, 'next', !!fromAutoplay);
    }

    function goPrev() {
      goToSlide(currentIndex - 1, 'prev', false);
    }

    function onTouchStart(e) {
      if (!isStackActive() || transitioning) return;
      var touch = e.touches && e.touches[0];
      if (!touch) return;
      touchStartX = touch.clientX;
      touchStartY = touch.clientY;
      touchActive = true;
      clearAutoplay();
    }

    function activeCard() {
      return getSlides()[currentIndex];
    }

    function onDragStart(e) {
      if (!MQ.matches || transitioning) return;
      var p = e.touches ? e.touches[0] : e;
      if (!p) return;
      dragStartX = p.clientX;
      dragStartY = p.clientY;
      dragDX = 0;
      dragLock = null;
      dragCard = activeCard();
      clearAutoplay();
    }

    function onDragMove(e) {
      if (!dragCard) return;
      var p = e.touches ? e.touches[0] : e;
      if (!p) return;

      var mx = p.clientX - dragStartX;
      var my = p.clientY - dragStartY;

      if (dragLock === null) {
        if (Math.abs(mx) < 6 && Math.abs(my) < 6) return;
        dragLock = Math.abs(mx) > Math.abs(my) ? 'x' : 'y';
      }
      if (dragLock === 'y') {
        dragCard = null;
        return;
      }

      dragDX = mx;
      dragCard.classList.add('is-dragging');
      var rot = Math.max(-MAX_DRAG_ROTATE, Math.min(MAX_DRAG_ROTATE, mx * 0.08));
      dragCard.style.transform = 'translateX(' + mx + 'px) rotate(' + rot + 'deg)';
      dragCard.style.opacity = '1';

      var reach = (slideshow.clientWidth || window.innerWidth || 375) * 0.6;
      var progress = Math.min(1, Math.abs(mx) / reach);

      var slides = getSlides();
      var total = slides.length;
      if (total > 1) {
        var goingNext = mx < 0;
        var incomingIndex = goingNext
          ? clampIndex(currentIndex + 1)
          : clampIndex(currentIndex - 1);
        var depthIndex = goingNext
          ? clampIndex(currentIndex + 2)
          : clampIndex(currentIndex + 1);
        var incoming = slides[incomingIndex];
        var depth = slides[depthIndex];
        var i;

        for (i = 0; i < total; i++) {
          var slide = slides[i];
          if (slide === dragCard) continue;

          if (slide === incoming || (depth && slide === depth && depth !== incoming)) {
            slide.style.removeProperty('opacity');
            slide.style.removeProperty('visibility');
            slide.style.removeProperty('pointer-events');
            if (slide !== incoming) {
              slide.style.removeProperty('transform');
              slide.style.removeProperty('transition');
              slide.style.removeProperty('z-index');
            }
            continue;
          }

          slide.style.transition = 'none';
          slide.style.opacity = '0';
          slide.style.visibility = 'hidden';
          slide.style.pointerEvents = 'none';
          slide.style.zIndex = '0';
        }

        if (incoming && incoming !== dragCard) {
          if (dragIncoming && dragIncoming !== incoming) {
            clearInlineStyles(dragIncoming);
          }
          dragIncoming = incoming;
          incoming.classList.remove('hdt-stack-hidden');
          incoming.style.transition = 'none';
          incoming.style.opacity = '1';
          incoming.style.visibility = 'visible';
          incoming.style.pointerEvents = 'none';
          incoming.style.zIndex = '3';
          incoming.style.transform =
            'translateX(0) scale(' + (0.94 + 0.06 * progress) + ') rotate(0deg)';
        }

        if (depth && depth !== dragCard && depth !== incoming) {
          depth.classList.remove('hdt-stack-hidden');
          depth.style.opacity = '1';
          depth.style.visibility = 'visible';
          depth.style.zIndex = '2';
          depth.style.transform = 'translateX(0) scale(0.88) rotate(0deg)';
        }

        var navIndex = currentIndex;
        if (goingNext && currentIndex < total - 1) navIndex = currentIndex + progress;
        else if (!goingNext && currentIndex > 0) navIndex = currentIndex - progress;
        setNavIndex(navIndex, true);
      }

      if (e.cancelable) e.preventDefault();
    }

    function onDragEnd() {
      if (!dragCard) return;
      var card = dragCard;
      var incoming = dragIncoming;
      dragCard = null;
      dragIncoming = null;

      card.classList.remove('is-dragging');
      card.style.removeProperty('transform');
      card.style.removeProperty('opacity');
      card.style.removeProperty('transition');
      card.style.removeProperty('visibility');
      card.style.removeProperty('pointer-events');
      card.style.removeProperty('z-index');
      if (incoming) {
        incoming.style.removeProperty('transform');
        incoming.style.removeProperty('opacity');
        incoming.style.removeProperty('transition');
        incoming.style.removeProperty('visibility');
        incoming.style.removeProperty('pointer-events');
        incoming.style.removeProperty('z-index');
      }

      getSlides().forEach(function (slide) {
        if (slide === card || slide === incoming) return;
        slide.style.removeProperty('transform');
        slide.style.removeProperty('opacity');
        slide.style.removeProperty('transition');
        slide.style.removeProperty('visibility');
        slide.style.removeProperty('pointer-events');
        slide.style.removeProperty('z-index');
      });

      if (dotsContainer) dotsContainer.classList.remove('is-nav-dragging');

      if (Math.abs(dragDX) > THROW_THRESHOLD) {
        if (dragDX < 0) goNext(false);
        else goPrev();
      } else {
        setNavIndex(currentIndex, false);
        applyStack(currentIndex, null);
        scheduleAutoplay();
      }
    }

    function onTouchEnd(e) {
      if (!touchActive || !isStackActive() || transitioning) return;
      touchActive = false;

      var touch = e.changedTouches && e.changedTouches[0];
      if (!touch) return;

      var diffX = touch.clientX - touchStartX;
      var diffY = touch.clientY - touchStartY;

      if (Math.abs(diffX) < SWIPE_THRESHOLD || Math.abs(diffY) > Math.abs(diffX)) {
        scheduleAutoplay();
        return;
      }

      if (diffX < 0) goNext(false);
      else goPrev();
    }

    function bindSwipe() {
      if (slideshow.dataset.stackSwipeBound === 'true') return;
      slideshow.dataset.stackSwipeBound = 'true';

      if (stackConfig.isProduct) {
        slideshow.addEventListener('touchstart', onDragStart, { passive: true, capture: true });
        slideshow.addEventListener('touchmove', onDragMove, { passive: false, capture: true });
        slideshow.addEventListener('touchend', onDragEnd, { passive: true, capture: true });
        slideshow.addEventListener('touchcancel', onDragEnd, { passive: true, capture: true });
        return;
      }

      var opts = { passive: true, capture: true };
      slideshow.addEventListener('touchstart', onTouchStart, opts);
      slideshow.addEventListener('touchend', onTouchEnd, opts);
      slideshow.addEventListener('touchcancel', function () {
        touchActive = false;
        scheduleAutoplay();
      }, opts);
    }

    function bindDots() {
      if (!dotsContainer || dotsContainer.dataset.stackDotsBound === 'true') return;
      dotsContainer.dataset.stackDotsBound = 'true';

      dotsContainer.addEventListener(
        'click',
        function (e) {
          if (!isStackActive() || transitioning || hideDotsOnDesktop()) return;
          var dot = e.target.closest('.hdt-slider__dot');
          if (!dot) return;

          var dots = dotsContainer.children;
          for (var i = 0; i < dots.length; i++) {
            if (dots[i] === dot) {
              e.preventDefault();
              e.stopImmediatePropagation();
              clearAutoplay();
              goToSlide(i, null, false);
              break;
            }
          }
        },
        true
      );
    }

    function bindNavButtons() {
      var prevBtn = slideshow.querySelector('.hdt-slider__button--prev');
      var nextBtn = slideshow.querySelector('.hdt-slider__button--next');

      if (prevBtn && !prevBtn.dataset.stackNavBound) {
        prevBtn.dataset.stackNavBound = 'true';
        prevBtn.addEventListener(
          'click',
          function (e) {
            if (!isStackActive()) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            clearAutoplay();
            goPrev();
          },
          true
        );
      }

      if (nextBtn && !nextBtn.dataset.stackNavBound) {
        nextBtn.dataset.stackNavBound = 'true';
        nextBtn.addEventListener(
          'click',
          function (e) {
            if (!isStackActive()) return;
            e.preventDefault();
            e.stopImmediatePropagation();
            clearAutoplay();
            goNext(false);
          },
          true
        );
      }

      enableNavButtons();
    }

    function teardownStack() {
      clearAutoplay();
      slideshow.removeAttribute('data-stack-ready');
      getSlides().forEach(function (slide) {
        clearStackClasses(slide);
        clearInlineStyles(slide);
      });
    }

    function onResize() {
      if (exitTimer) {
        clearTimeout(exitTimer);
        exitTimer = null;
      }
      transitioning = false;

      if (isStackActive()) {
        bindSwipe();
        bindDots();
        bindNavButtons();
        ensureDots();
        applyStack(currentIndex, null);
        scheduleAutoplay();
      } else {
        teardownStack();
      }
    }

    function bootstrap() {
      if (!isStackActive()) return;

      var configStart = 0;
      try {
        var cfg = JSON.parse(slideshow.getAttribute('config') || '{}');
        if (Number.isFinite(cfg.startIndex) && cfg.startIndex >= 0) {
          configStart = cfg.startIndex;
        }
      } catch (e) {}

      if (MQ.matches || stackConfig.stackAlways) {
        currentIndex = clampIndex(configStart);
      } else {
        getSlides().forEach(function (slide, index) {
          if (slide.classList.contains('is-selected')) currentIndex = index;
        });
      }

      watchDotsContainer();
      watchNavResize();
      bindEmblaStackGuard();
      bindSwipe();
      bindDots();
      bindNavButtons();
      ensureDots();
      applyStack(currentIndex, null);
      scheduleAutoplay();
    }

    bindEmblaStackGuard();
    if (isStackActive()) bootstrap();

    MQ.addEventListener('change', onResize);
    MQ_DESKTOP.addEventListener('change', onResize);

    slideshow.addEventListener('mouseenter', clearAutoplay);
    slideshow.addEventListener('mouseleave', scheduleAutoplay);

    document.addEventListener('visibilitychange', function () {
      if (document.hidden) clearAutoplay();
      else scheduleAutoplay();
    });

    function watchHiddenSlides() {
      if (!stackConfig.isProduct) return;
      var container = slideshow.querySelector(viewportSelector + ' .hdt-slider__container');
      if (!container || container.dataset.stackHiddenWatch === 'true') return;
      container.dataset.stackHiddenWatch = 'true';

      new MutationObserver(function () {
        if (!isStackActive()) return;
        currentIndex = Math.min(currentIndex, Math.max(getTotal() - 1, 0));
        ensureDots();
        applyStack(currentIndex, null);
      }).observe(container, {
        attributes: true,
        subtree: true,
        attributeFilter: ['hidden']
      });
    }

    watchHiddenSlides();

    var sliderTag = slideshow.tagName.toLowerCase();
    if (customElements.get(sliderTag)) {
      setTimeout(bootstrap, 100);
    } else {
      customElements.whenDefined(sliderTag).then(function () {
        setTimeout(bootstrap, 100);
      });
    }
  }

  function initAll() {
    document.querySelectorAll(STACK_ROOT_SELECTOR).forEach(initStackSlideshow);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', initAll);
})();
